<script lang="ts">
  import { formatCurrency } from '$lib/utils/currency';
  import currency, { type default as Currency } from 'currency.js';
  import { getContext } from 'svelte';

  export let amount: number | string | Currency | BigInt;
  export let currencyId: string;
  export let fromCents: boolean | undefined = undefined;
  export let convert = false;
  export let hideCurrency = false;

  const globalCtx = getContext('global') as App.GlobalCtx;

  export const getCurrencySymbol = (currency: string, locale = 'en-US') =>
    // @ts-expect-error
    new Intl.NumberFormat(locale, { style: 'currency', currency }).formatToParts(1).find((x) => x.type === 'currency')
      .value;

  // @ts-expect-error
  $: finalAmount = currency(typeof amount === 'bigint' ? amount.toString() : amount, { fromCents });
  $: finalCurrencyId = currencyId;

  $: if (convert && globalCtx.userSettings.convertPricesToUSD && currencyId !== 'USD') {
    const rate = 1 / globalCtx.currencyExchangeRates.rates.EUR;
    finalAmount = finalAmount.multiply(rate);
    finalCurrencyId = 'USD';
  }
</script>

{formatCurrency(finalAmount, finalCurrencyId, { hideCurrencySymbol: hideCurrency })}
